/** What asking the browser for a newer worker came to. */
export enum ServiceWorkerUpdateResult {
  /** A newer worker installs or waits: the update banner follows. */
  started = 'started',
  /** No newer worker was found (yet), or the check failed: a later check may start it. */
  notStarted = 'not-started',
  /** The page has no worker registration: no check can ever start an update. */
  noWorker = 'no-worker',
}

export function isServiceWorkerUpdateStarted(result: ServiceWorkerUpdateResult): boolean {
  return result === ServiceWorkerUpdateResult.started;
}

export function isServiceWorkerMissing(result: ServiceWorkerUpdateResult): boolean {
  return result === ServiceWorkerUpdateResult.noWorker;
}
